import { useEffect, useState } from 'react'
import type { AdminSectionProps } from './types'
import { db } from '@core/db/db'
import { pluralRuCount } from '@core/utils/plural'
import { UsersSection } from './UsersSection'
import { AdminCard } from './AdminCard'
import { useAuthToken } from './useAuthToken'

/** Раздел «Сотрудники»: RBAC-управление кассирами и правами. */
export function StaffSection({ cashier }: AdminSectionProps) {
  const token = useAuthToken()
  const [cashiers, setCashiers] = useState(0)

  useEffect(() => {
    let cancelled = false
    void db.cashiers
      .count()
      .then((count) => {
        if (!cancelled) setCashiers(count)
      })
      .catch(() => undefined)
    return () => {
      cancelled = true
    }
  }, [])

  if (cashier?.role !== 'admin') {
    return (
      <div className="rounded-panel border border-line bg-white p-4 text-small text-muted">
        Управление сотрудниками доступно только администратору.
      </div>
    )
  }

  return (
    <AdminCard
      id="staff.users"
      title="Управление кассирами и правами доступа"
      defaultOpen
      meta={
        cashiers > 0 ? (
          <span className="text-small font-normal text-muted">
            {pluralRuCount(cashiers, ['сотрудник', 'сотрудника', 'сотрудников'])}
          </span>
        ) : undefined
      }
    >
      <UsersSection token={token} />
    </AdminCard>
  )
}
